import Vue from 'vue';
import Vuex from 'vuex';
import Endpoints from '../api';
import localStorage from '../helpers/localStorage';

const productIndexInCart = (products, id) => products.findIndex(p => p.id === id)

const passes_store = new Vuex.Store({
  state: {
    // total_products: 0,
    passes_cart: [],
    // price_total: 0,
    products: [],
  },

  getters: {
    count: (state) => state.passes_cart.reduce((total, p) => total += parseInt(p.quantity), 0),
    total: (state) => state.passes_cart.reduce((total, p) => total += parseInt(p.unit_price)*parseInt(p.quantity), 0)
  },

  mutations: {
    increment (state, {item}) {
        item.quantity++;
        const productIndex = productIndexInCart(state.passes_cart, item.id);
          if (!~productIndex) {
              state.passes_cart.push({...item, quantity: item.quantity});
          } else {
              const product = state.passes_cart[productIndex];
              state.passes_cart.splice(productIndex, 1, {...product, quantity: item.quantity})
          }
        Endpoints.passes.update.post(state.passes_cart).then(function(data){
          if ("cart" in data){
              localStorage.save("passes_cart",data["cart"])
          }
        });

    },
    decrement (state, {item}) {
        if (state.passes_cart.length) {
            const productIndex = productIndexInCart(state.passes_cart, item.id);
            if (~productIndex && item.quantity > 0) {
                item.quantity--;

                const product = state.passes_cart[productIndex];
                state.passes_cart.splice(productIndex, 1, {...product, quantity: item.quantity});

                if (item.quantity === 0) {
                    state.passes_cart.splice(productIndex, 1);
                }
            }
        }
        Endpoints.passes.update.post(state.passes_cart).then(function(data){
          if ("cart" in data){
              localStorage.save("passes_cart",data["cart"])
          }
        });

        // if(state.total_products > 0){
        //     if(payload.item.id in state.passes_cart){
        //         state.passes_cart[payload.item.id].quantity--
        //         state.total_products--;
        //         if(state.passes_cart[payload.item.id].quantity <= 0){
        //             delete state.passes_cart[payload.item.id]
        //         }
        //         state.price_total = state.price_total - payload.item.unit_price;
        //         Endpoints.passes.update.post(state.passes_cart).then(function(data){
        //             if ("cart" in data){
        //                 localStorage.save("passes_cart",data["cart"])
        //             }
        //         });
        //     }
        // }
    },
    add_products(state, payload){
        Endpoints.passes.get_cart.post(state.passes_cart).then(function(data) {

            state.products = payload["products"];
            state.passes_cart = [];

            // if ("products" in data){
            //     state.products = data["products"]
            // }
            // else{
            //     state.products = payload.products
            // }

            // [product1, product2, product3]
            // []

            // if ("cart" in data) {
            //     state.passes_cart = data["cart"]
            // }
        });
    }
 },
 actions: {
     // context = {state, commit, etc...}
     increment({commit}, payload) {
        commit("increment", payload);
    },
     decrement({commit}, payload) {
        commit("decrement", payload);
    },
     add_products({commit}, payload) {
        commit("add_products", payload);
     }
 }
})

export {passes_store};



// WEBPACK FOOTER //
// ./src/helpers/passesHelper.js